/**
 * Returns columns for Sections list (DataTable component).
 * Plain factory — do not use hooks here (called during parent render).
 */
const Columns = ({ getName, getActions }) => [
  {
    id: "name",
    header: "Name",
    accessor: (row) => getName(row),
    sortable: true,
    searchable: true,
  },
  {
    id: "actions",
    header: "Actions",
    accessor: null,
    cell: (_, row) => getActions(row),
    sortable: false,
    searchable: false,
  },
];

export default Columns;
